import { decorate, observable, action } from 'mobx';
import * as Api from '../lib/api';

export class OrderStore {
    loading = false;
    success = false;
    fieldsLoading = false;

    userData = null;
    rentFields = [];
    models = [];

    values = {};
    product = {};

    // Get actions
    getRentFields = categoryId => {
        this.fieldsLoading = true;

        Api.fetch(`order/rent-fields/${categoryId}`)
            .then(response => {
                if (response.success) {
                    this.rentFields = response?.result?.fields;
                    this.userData = response?.result?.user;
                }
            })
            .finally(() => {
                this.fieldsLoading = false;
            });
    };

    getProductModels = productId => {
        this.fieldsLoading = true;

        Api.fetch(`product/${productId}/models`)
            .then(response => {
                if (response.success) {
                    this.models = response?.result;
                }
            })
            .finally(() => {
                this.fieldsLoading = false;
            });
    };

    // Set actions
    setValues = values => {
        this.values = {
            ...this.values,
            ...values,
        };
    };

    setProduct = product => {
        if (product) {
            this.product = product;
        }
    };

    // Handler actions
    handleInputChange = e => {
        this.values = {
            ...this.values,
            [e.target.name]: e.target.value,
        };
    };

    handleChange = (name, value) => {
        this.values = {
            ...this.values,
            [name]: value,
        };
    };

    handleCheckboxChange = e => {
        this.values = {
            ...this.values,
            [e.target.name]: !this.values[e.target.name],
        };
    };

    // Send order to buy
    sendOrderToBuy = (productId, onClose) => {
        this.loading = true;

        const data = {
            productId: productId,
            utm: 'utm_lk_zayavka',
            companyName: this.values.companyName,
            phone: this.values.name,
            contact: this.values.phone,
            comment: this.values.comment,
        };

        Api.fetch('order/purchase', data, 'POST')
            .then(response => {
                if (response.success) {
                    onClose();
                    this.success = true;
                    this.values = {};
                }
            })
            .finally(() => {
                this.loading = false;
                setTimeout(() => {
                    this.success = false;
                }, 3000);
            });
    };

    resetRentFields = () => {
        this.rentFields = [];
        this.fieldsLoading = false;
        this.models = false;
    };
    resetValues = () => {
        this.product = [];
        this.values = [];
    };
}

decorate(OrderStore, {
    loading: observable,
    success: observable,
    fieldsLoading: observable,

    userData: observable,
    regions: observable,
    shifts: observable,
    fillers: observable,
    services: observable,

    rentFields: observable,
    models: observable,

    values: observable,
    product: observable,

    getRegions: action,
    getShifts: action,
    getFillers: action,
    getRentFields: action,
    getProductModels: action,

    setValues: action,
    setProduct: action,

    handleInputChange: action,
    handleChange: action,
    handleCheckboxChange: action,

    sendOrderToBuy: action,

    resetRentFields: action,
});
